import { render } from "./ShortcutIcon.vue?vue&type=template&id=122c04c8"
import script from "./ShortcutIcon.vue?vue&type=script&lang=js"
export * from "./ShortcutIcon.vue?vue&type=script&lang=js"

import "./ShortcutIcon.vue?vue&type=style&index=0&id=122c04c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__